import {
  ADD_COURSES_DIALOG,
  ADD_COURSE_MODAL_SCROLL_RESTORED,
  COURSE_RESET_DATA,
  COURSE_ITEM_CHANGE,
  SET_ADD_COURSE_MODAL_SCROLL,
} from './types';

export const addCoursesDialogOpen = isOpen => ({
  type: ADD_COURSES_DIALOG,
  payload: isOpen,
});

export const onResetCourseData = () => ({
  type: COURSE_RESET_DATA,
});

export const courseItemChange = item => ({
  type: COURSE_ITEM_CHANGE,
  payload: item,
});

/** Save scroll for add-course modal. moduleIndex = lesson to scroll into view (optional). */
export const setAddCourseModalScroll = (
  scrollTop,
  restoreCount = 5,
  moduleIndex = null,
) => ({
  type: SET_ADD_COURSE_MODAL_SCROLL,
  payload: { scrollTop, restoreCount, moduleIndex },
});

export const addCourseModalScrollRestored = () => ({
  type: ADD_COURSE_MODAL_SCROLL_RESTORED,
});
